<template>
  <!-- 解决方案内容页 -->
  <div id="fgartic">
    <div class="w12cen between">
      <fgarticont class="cont" :hidetop="hidenum" />
      <div class="right">
        <fanganys class="jjfays" />
        <fghotj class="hotfatj mt30" />
        <!-- <fangancalc class="syjsq mt30" /> -->
        <div class="myzx mt30" ref="articrighttop">
          <img src="../../assets/jpcol/fananzxbg_sample.png" class="fgbg" />
          <div class="btn">我要咨询</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fgarticont from "./child/fgarticont";
import fanganys from "views/fangan/components/fanganys";
import fghotj from "views/fangan/components/fghotj";
import fangancalc from "views/fangan/components/fangancalc";

export default {
  name: "fgartic",
  components: {
    fgarticont,
    fanganys,
    fghotj,
    fangancalc,
  },
  data: () => ({
    hidenum: 0,
  }),
  mounted() {
    this.hidenum =
      this.$refs.articrighttop.offsetHeight +
      this.$refs.articrighttop.offsetTop;
  },
};
</script>

<style lang="scss" scoped>
#fgartic {
  background-color: #f8f8f8;
  .w12cen {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
  }
  .cont {
    width: 855px;
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
  }
  .right {
    width: 315px;
    .jjfays {
      width: 100%;
      height: 332px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
    .hotfatj {
      width: 100%;
      height: 278px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
    .syjsq {
      width: 100%;
      height: 260px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
    .myzx {
      position: relative;
      width: 100%;
      height: 208px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      .fgbg {
        position: absolute;
        top: 0;
        left: 0;
      }
      .btn {
        cursor: pointer;
        position: absolute;
        top: 145px;
        left: 52px;
        width: 100px;
        height: 26px;
        text-align: center;
        background: #ffffff;
        border-radius: 13px;
        font-size: 16px;
        color: #3873e8;
        line-height: 26px;
      }
    }
  }
}
</style>